import { ReportSummaryMapping } from '../../../../components/report/redesigned';
import { ReportSummaryInterface } from '../../../common/ReportSummaryInterface';

export interface AdminPayoutsSummary extends ReportSummaryInterface {
  grossAmount: number;
  buyerAmount: number;
  supplierAmount: number;
  paymentProcessorAmount: number;
  securspaceAmount: number;
  payoutsCount: number;
  transactionCount: number;
}

export const adminPayoutsSummaryMapping = [
  { id: 'grossAmount', label: 'Total Gross Amount', formatter: 'currency' },
  { id: 'buyerAmount', label: 'Total Buyer Amount', formatter: 'currency' },
  { id: 'paymentProcessorAmount', label: 'Total Payment Processor Amount', formatter: 'currency' },
  { id: 'securspaceAmount', label: 'Total SecurSpace Amount', formatter: 'currency' },
  { id: 'supplierAmount', label: 'Total Supplier Amount', formatter: 'currency' },
] satisfies ReportSummaryMapping[];